import script from "./VPSView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VPSView.vue?vue&type=script&lang=ts&setup=true"

import "./VPSView.vue?vue&type=style&index=0&id=69b335e7&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b335e7"]])

export default __exports__